exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/@storybook/components/~/core-js/internals/object-get-own-property-symbols.js
// module id = 147
// module chunks = 168707334958949